const losDictionary = {
  // LOS API endpoints
  leadToApplication: () => "/api/v1/processio/lead-to-application",
  updateLead: () => "/api/v1/processio/update-lead",
  createUpdateApplicantBasicDetails: () =>
    "/api/v1/processio/create-update-applicant-basic-details",
  createUpdateApplicantDemographicDetails: () =>
    "/api/v1/processio/create-update-applicant-demographic-details",
  emailAndMobileVerification: () =>
    "/api/v1/processio/email-and-mobile-verification",
  panVerification: () => "/api/v1/processio/pan-verification",
  saveEmploymentDetails: () => "/api/v1/processio/save-employment-details",
  saveExpense: () => "/api/v1/processio/save-expense",
  saveReference: () => "/api/v1/processio/save-reference",
  updateReference: () => "/api/v1/processio/update-reference",
  saveCollateral: () => "/api/v1/processio/save-collateral",
  createCollateral: () => "/api/v1/processio/create-collateral",
  saveLoanRequirement: () => "/api/v1/processio/save/loan-requirement",
  saveAcademicDetails: () => "/api/v1/processio/save-academic-details",
  saveUpdateEntranceExamsDetails: () =>
    "/api/v1/processio/save-update-entrance-exams-details",
  //saveCoApplicant: () => "/api/v1/processio/save-co-applicant",
  piiGetKey: () => "/api/v1/processio/pii/getKey",
  getCoApplicantFields: () => "/api/v1/product/co-applicant-fields",
  storeUserFields: () => "/api/v1/product/store-user-fields",
  deleteUserFields: () => "/api/v1/product/delete-user-fields",
  saveCoApplicantFormData: () => "/api/v1/applicant/save-coapplicant",
  relationMaster: () => "/api/v1/master/journey-pennant-relationship-master",
  getCoApplicantDetails: () => `/api/v1/applicant/get-coapplicant-details`,
  getReferenceIds: (trackingId: string) =>
    `/api/v1/processio/get-reference-ids/${trackingId}`,
  getDataByLeadId: () => "/api/v1/processio/getdata-byleadId",

  // Add more LOS API endpoints here as needed
  // createApplication: () => "/los/application/create",
  // updateApplication: (id: string) => `/los/application/${id}`,
  // getApplication: (id: string) => `/los/application/${id}`,
  // submitApplication: () => "/los/application/submit",
  // getApplicationStatus: (id: string) => `/los/application/${id}/status`,
};

export default losDictionary;
